import { render, staticRenderFns } from "./BrushSize.vue?vue&type=template&id=8d9bef34&scoped=true&"
import script from "./BrushSize.vue?vue&type=script&lang=js&"
export * from "./BrushSize.vue?vue&type=script&lang=js&"
import style0 from "./BrushSize.vue?vue&type=style&index=0&id=8d9bef34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d9bef34",
  null
  
)

export default component.exports